
import React from 'react';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';

export const CustomDateTimePicker = ({ label, value, onChange }) => {
  return (
    <TextField
      label={label}
      type="datetime-local"
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputLabelProps={{ shrink: true }}
      sx={{ width: '100%' }}
    />
  );
};

CustomDateTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
